import React from "react"
import { useRouteMatch } from "react-router-dom"

import useUserFromToken from "hooks/useUserFromToken"

import ConvertingInputGrid from "./ConvertingInputGrid"
import ConvertingOutputGrid from "./ConvertingOutputGrid"
import RecyclingInputGrid from "./RecyclingInputGrid"
import RecyclingOutputGrid from "./RecyclingOutputGrid"
import SorterOutputGrid from "./SorterOutputGrid"
import SorterRecyclerOutputGrid from "./SorterRecyclerOutputGrid"

// Routes mounted under this dispatcher:
//   /submissions/new/:type            -> recycling / sorting input & output
//   /submissions/new-converting/:type -> converter input & output
//
// Picks the right per-role grid based on the URL segment + current user role.
const SubmissionGridRouter: React.FC = () => {
  const { params, path } = useRouteMatch<{ type?: string }>()
  const { isSorter, isSorterAndRecycler } = useUserFromToken()
  const type = params.type
  const isConverterRoute = path.includes("/new-converting/")

  if (isConverterRoute) {
    if (type === "input") return <ConvertingInputGrid />
    if (type === "output") return <ConvertingOutputGrid />
    return null
  }

  if (type === "input") {
    // Sorter/Sorter+Recycler reuse RecyclingInputGrid; row save logic sets
    // Submission.type correctly per role.
    return <RecyclingInputGrid />
  }

  if (type === "output") {
    if (isSorter) return <SorterOutputGrid />
    if (isSorterAndRecycler) return <SorterRecyclerOutputGrid />
    return <RecyclingOutputGrid />
  }

  return null
}

export default SubmissionGridRouter
